import Component from "@glimmer/component"
import styles from "./planbook-explanation.module.css"

export default class UserOnboardingPlanbookExplanationComponent extends Component {
  readonly styles = styles
}
